export const maxRubricCommentLength = 140;
export const maxYNCommentLength = 140;
